import { Injectable } from '@angular/core';
import {
  BusinessProfile,
  BusinessProfileView,
  PersonalProfileSelectorView,
  ProfileSelectorFooterData,
  ProfileSelectorHeaderContent
} from '@com-delta-idp/mnx-sitewide-shared-core-ui';
import * as CONSTANTS from '../../constants/profile-selector/profile-selector-constants';
import { OauthAEMConfig } from '../../models/login';
import {
  CompanyDescription,
  PermissionTypeAEM,
  URL
} from '../../models/profile-selector/profile-selector-aem.interface';
import { BusinessListAttributes } from '../../models/profile-selector/profile-selector.interface';
import { ProfileSelectorAdapterHelperSupportExtendedService } from './profile-selector-adapter-helper-support-extended.service';
@Injectable({ providedIn: 'root' })
export class ProfileSelectorAdapterHelperSupportService extends ProfileSelectorAdapterHelperSupportExtendedService {
  corpAgreementTypeAndProgramList!: string;
  permType: string[] | undefined;
  firstName: string | undefined = '';
  lastName: string | undefined = '';
  profileSelectorPageFooter = {} as ProfileSelectorFooterData;
  footerSubTitle = '';
  footerSubTitleNoTerms = '';
  businessTitle = '';
  personalTitle = '';
  pageHeader = {} as ProfileSelectorHeaderContent;
  deltaLogoUrl = '';
  personalProfileView = {} as PersonalProfileSelectorView;
  businessProfileView = {} as BusinessProfileView;
  businessProfile: BusinessProfile[] | undefined;
  headerTitle = '';
  headerSubTitle = '';
  permissionTypes = {} as PermissionTypeAEM[];
  altText = '';
  userId: string[] | '' = '';
  nuTravelEAMFlag = '';
  postCorporateFlag = false;

  setCorporateCode(): void {
    this.corpAgreementTypeAndProgramList =
      CONSTANTS.APP_CORPORATE_AGREEMENT_TYPE_CODE;
    if (this.corpAgreementTypeAndProgramList.length > 0) {
      const corpList = this.corpAgreementTypeAndProgramList.split(',');
      corpList.forEach((corpAgreementKey: string) => {
        const tempKey = corpAgreementKey.split(':')[0];
        const tempVal = corpAgreementKey.split(':')[1];
        CONSTANTS.CorpAgreementData[tempKey] = tempVal;
      });
    }
  }

  getPermissionListHelper(index: number): {
    readingFromAem: string;
    program: string;
  } {
    const readingFromAem = this.permType
      ? `permType_${this.permType[index]}`
      : '';
    const program = this.program ? this.program[index] : '';
    return {
      readingFromAem,
      program
    };
  }

  isTermsDisplay(): boolean {
    let displayTermsOfUse = false;
    if (this.crprtAgrmntTypeCode) {
      this.crprtAgrmntTypeCode.forEach((code) => {
        if (
          code === CONSTANTS.CORPORATE_AGREEMENT_TYPE_CODE.SME ||
          code === CONSTANTS.CORPORATE_AGREEMENT_TYPE_CODE.NTVL
        ) {
          displayTermsOfUse = true;
        }
      });
    }
    if (this.program) {
      this.program.forEach((code) => {
        if (
          code === CONSTANTS.PROGRAM_TYPE.SKYB ||
          code === CONSTANTS.PROGRAM_TYPE.SKB
        ) {
          displayTermsOfUse = true;
        }
      });
    }
    return displayTermsOfUse;
  }

  getBusinessListHelper(index: number): BusinessListAttributes {
    const { readingFromAem, program } = this.getPermissionListHelper(index);
    return {
      program: program,
      title: this.title[readingFromAem as keyof CompanyDescription],
      description:
        this.companyDescription[readingFromAem as keyof CompanyDescription],
      urlToRedirect: this.url[readingFromAem as keyof URL]
    };
  }

  getRedirectUrl(
    name: string,
    index: number,
    authConfig: OauthAEMConfig
  ): string {
    const currentOrigin = window.location.origin;
    const cpAgtId = this.isCorpAgreeIdPresent(this.crprtAgrmntId[index]);
    const { isOaSmeAccount } = this.isOaSME(name, cpAgtId);
    const restrictOnePax = this.getBusinessOption(
      CONSTANTS.BUSINESS_OPTIONS.restrictOnePax,
      index,
      cpAgtId,
      isOaSmeAccount
    );
    const disableMiles = this.getBusinessOption(
      CONSTANTS.BUSINESS_OPTIONS.disableMiles,
      index,
      cpAgtId,
      isOaSmeAccount
    );
    const partnerId = btoa(
      this.getBusinessOption(
        CONSTANTS.BUSINESS_OPTIONS.partnerId,
        index,
        cpAgtId,
        isOaSmeAccount
      )?.toString() ?? ''
    );
    const company = btoa(this.profileSelectorUtilService.getName(name));
    const displayText = btoa(
      this.getBusinessOption(
        CONSTANTS.BUSINESS_OPTIONS.displayInlineText,
        index,
        cpAgtId,
        isOaSmeAccount
      )?.toString() ?? ''
    );
    const corporateId = btoa(this.crprtAgrmntId[index]);
    const returnUrl = `${currentOrigin}${authConfig.LOGIN_STANDALONE_PAGE_URL}?fromAdmin=true&companyName=${company}&accountIndex=${index}&isOaSmeAccount=${isOaSmeAccount}&partnerId=${partnerId}&restrictPaxToOne=${restrictOnePax}&displayInlineText=${displayText}&disableMiles=${disableMiles}&corporateId=${corporateId}`;
    return returnUrl;
  }
}
